import React, { FunctionComponent } from 'react';
import styles from './Spinner.module.css';

const Spinner: FunctionComponent = () => (
    <div className={styles.root}>Loading...</div>
);

export default Spinner;